module.exports = __webpack_public_path__ + "img/unlike-def.12e3c2e1.png";